import Icon from "@core-components/icon/Icon";
import EPublicRoutes, { EPrivateRoutes } from "@core-types/routes.enum";
import { useAppNavigate } from "@hooks/language/useAppNavigate";
import useAppTranslation from "@hooks/language/useAppTranslation";
import { Button } from "@mantine/core";
import Coins, { ECoinVariant } from "@modules/clientDashboard/components/Coins";
import useUserStore from "@store/user.store";
import { IconChevronRight, IconLogout } from "@tabler/icons-react";
import { type ReactNode, useCallback, useMemo } from "react";

const SideBar: React.FC = () => {
  const { logout } = useUserStore();
  const { t } = useAppTranslation("components.layout.sidebar");
  const { navigate } = useAppNavigate();

  const handleLogout = () => {
    logout();
    navigate(EPublicRoutes.HOME);
  };

  // TODO : refacto this method 🤮
  const sideItem = useCallback(
    (
      label: string,
      icon: ReactNode,
      href: string,
      className?: string,
      currentClassName?: string,
    ) => {
      const isCurrentHref = window.location.href.includes(href);

      return (
        <Button
          key={label}
          radius={10}
          variant={isCurrentHref ? "gradient" : "transparent"}
          className={`group ${
            isCurrentHref
              ? "gradient-purple-blue"
              : " hover:gradient-purple-blue "
          }`}
          classNames={{
            inner: "justify-start",
            label: `transition text-[16px] ${
              isCurrentHref
                ? "text-primary-white"
                : "text-primary-dark-text group-hover:text-primary-white"
            }`,
            section: "ml-auto",
          }}
          rightSection={
            <IconChevronRight className={`${!isCurrentHref && "invisible"}`} />
          }
          onClick={() => navigate(href)}
        >
          <span
            className={`!h-[25px] !w-[25px] mr-2 ${className} ${isCurrentHref ? currentClassName : ""}`}
          >
            {icon}
          </span>
          {label}
        </Button>
      );
    },
    [navigate],
  );

  const sideItems = useMemo(
    () => [
      sideItem(
        t("orders"),
        <Icon.Bag className="group-hover:brightness-200" />,
        EPrivateRoutes.ORDERS,
        "mb-1",
        "brightness-200",
      ),
      sideItem(
        t("rewards"),
        <Coins variant={ECoinVariant.REWARDS} size={25} />,
        EPrivateRoutes.REWARDS,
      ),
      sideItem(
        t("fidelity"),
        <Coins variant={ECoinVariant.FIDELITY} size={25} />,
        EPrivateRoutes.FIDELITY,
      ),
      sideItem(
        t("referral"),
        <Coins variant={ECoinVariant.AFFILIATE} size={25} />,
        EPrivateRoutes.AFFILIATION,
      ),
      sideItem(
        t("help"),
        <Icon.LifeBuoy size={25} className="group-hover:brightness-200" />,
        EPrivateRoutes.HELP,
        "mb-1",
        "brightness-200",
      ),
    ],
    [sideItem, t],
  );

  return (
    <div className="z-10 hidden min-h-[800px] w-[300px] flex-col gap-4 border-r-[1px] border-r-primary-lighter bg-primary-client px-4 pt-14 md:flex">
      {sideItems}
      <Button
        radius={10}
        variant={"transparent"}
        classNames={{
          inner: "justify-start",
          label: "transition text-[16px] text-danger-default",
        }}
        onClick={handleLogout}
      >
        <IconLogout size={25} className="mr-2 mb-1 text-danger-default" />
        {t("logout")}
      </Button>
    </div>
  );
};

export default SideBar;
